import type { NativeStackNavigationOptions } from "@react-navigation/native-stack"

export type AppScreenOptions =
  | NativeStackNavigationOptions
  | ((props: {
      navigation: unknown
      route: { params?: Record<string, unknown> }
    }) => NativeStackNavigationOptions)

type ScreenOptionsContext = {
  navigation: unknown
  route: { params?: Record<string, unknown> }
}

export function resolveScreenOptions(
  options: AppScreenOptions | undefined,
  ctx: ScreenOptionsContext,
): NativeStackNavigationOptions {
  if (!options) return {}
  return typeof options === "function" ? options(ctx as never) : options
}

export function resolveScreenTitle(
  fallbackName: string,
  options: AppScreenOptions | undefined,
  ctx: ScreenOptionsContext,
): string {
  const resolved = resolveScreenOptions(options, ctx)
  return typeof resolved.title === "string" ? resolved.title : fallbackName
}
